import PropTypes from 'prop-types';
import { formatCo2e } from '@/utils/gconUtils';

const BarList = ({ items, label }) => {
  const max = Math.max(...items.map(i => i.total_co2e), 1);
  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">{label}</p>
      {items.map(item => (
        <div key={item.name} className="flex items-center gap-2">
          <span className="text-xs text-gray-600 w-28 truncate flex-shrink-0" title={item.name}>
            {item.name || '—'}
          </span>
          <div className="flex-1 bg-gray-100 rounded-full h-1.5">
            <div className="bg-teal-400 h-1.5 rounded-full" style={{ width: `${(item.total_co2e / max) * 100}%` }} />
          </div>
          <span className="text-xs text-gray-500 w-16 text-right">{formatCo2e(item.total_co2e)}</span>
        </div>
      ))}
    </div>
  );
};

BarList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, total_co2e: PropTypes.number })).isRequired,
  label: PropTypes.string.isRequired,
};

export default BarList;
